import React from 'react'
import './SidebarChannel.css'
import { selectChannelID, setChannelInfo, deleteChannel } from "./features/appSlice";
import { useDispatch, useSelector } from 'react-redux'
import { MdDelete } from 'react-icons/md'
import { db } from './firebase'

function SidebarChannel({id, channelName}) {
    const dispatch = useDispatch();
    const activeChannelID = useSelector(selectChannelID);

    const handleDeleteChannel = () => {
      dispatch(deleteChannel({ channelID: id }))
    }

  return (
    <div onClick={() => dispatch(
        setChannelInfo({
            channelID: id,
            channelName: channelName,
        })
    )} className='sidebarChannel' >
      <div
      className={`sidebarChannel ${id === activeChannelID ? 'active' : ''}`}>
        <h4>
        {channelName}
        </h4>
        <MdDelete className='delete' onClick={handleDeleteChannel} />
      </div>
    </div>
  )
}

export default SidebarChannel